import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "../components/icons";
import iconStyles from "../components/icons/index.module.scss";
import styles from "./index.module.scss";
export default ({ value, options, onChange, }) => {
    const [open, setOpen] = useState(false);
    const containerReference = useRef(null);
    const selected = options.find((option) => option.value === value) ?? options[0];
    const stripLabelPrefix = (label) => label.replace(/^[^:]+:\s*/, "");
    useEffect(() => {
        if (!open)
            return;
        const handleClickOutside = (event) => {
            if (containerReference.current &&
                !containerReference.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open]);
    return (React.createElement("div", { className: styles.filterSelectWrap, ref: containerReference },
        React.createElement("button", { type: "button", className: `${styles.filterSelect} ${open ? styles.filterSelectOpen : ""}`, "aria-expanded": open, "aria-haspopup": "listbox", onClick: () => setOpen((current) => !current) },
            React.createElement("span", null, selected.label),
            React.createElement(ChevronDown, { className: `${iconStyles.icon} ${iconStyles.chevronDown}` })),
        open && (React.createElement("ul", { className: styles.filterMenu, role: "listbox" }, options.map((option) => (React.createElement("li", { key: option.value, role: "option", "aria-selected": value === option.value },
            React.createElement("button", { type: "button", className: styles.filterOption, onClick: () => {
                    onChange(option.value);
                    setOpen(false);
                } }, stripLabelPrefix(option.label)))))))));
};
